export default "__VITE_ASSET__595c31fc__"